import { css } from '@emotion/react';

export const mapContainer = css`
  svg {
    height: 437px;
    width: 453px;
  }
`;
